<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BroadcastDetail from '../../../../../broadcasts/components/BroadcastDetail.vue'
import { BroadcastID } from '../../../../../broadcasts/models/broadcast'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})

const {
  id,
} = defineProps<{
    id: BroadcastID
}>()
</script>

<template>
  <BroadcastDetail
    :id="id"
  />
</template>